import { BRAND_LIST } from 'typings'
import * as Typings from '../typings'

const AustraliaLocale: Typings.LocaleType = {
  REGION: Typings.RegionGroupNames.SOUTH_EAST_ASIA,
  CODE: 'au',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Australia',
  SHORT_NAME: 'AU',

  DISPLAY_NAME: 'Australia (English)',
  DISPLAY_COUNTRY: 'Australia',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: -25.2744,
    INITIAL_LONGITUDE: 133.7751,
    INITIAL_ZOOM: 4,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/au/en/',

  MAP_URL: 'https://www.uniqlo.com/au/shop',

  TERMS_OF_USE_URL:
    'https://faq-au.uniqlo.com/pkb_Home?l=en_US&c=category_uq%3AUQAU_C7_1',
  PRIVACY_POLICY_URL:
    'https://faq-au.uniqlo.com/pkb_Home?id=kA0Ie000000TORV&l=en_US&fs=Search&pn=1',

  CONTACT_US_URL: 'https://faq-au.uniqlo.com/',

  POSTCODE_FORMAT: /[0-9]{4}/g,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  AM_FORMAT: ' AM',
  PM_FORMAT: ' PM',

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
  CMS_ENABLED: {
    [BRAND_LIST.UQ]: true,
  },
}

export default AustraliaLocale
